import account from './sagas/account';
import attachments from './sagas/attachments';
import bookmarks from './sagas/bookmarks';
import builds from './sagas/builds';
import categories from './sagas/categories';
import categorySummary from './sagas/categorySummary';
import couponFavorites from './sagas/couponFavorites';
import googleAnalytics from './sagas/googleAnalytics';
import icons from './sagas/icons';
import invoices from './sagas/invoices';
import myOfferings from './sagas/myOfferings';
import myWanteds from './sagas/myWanteds';
import notifications from './sagas/notifications';
import offerings from './sagas/offerings';
import offeringVideos from './sagas/offeringVideos';
import offeringReviews from './sagas/offeringReviews';
import paymentMethod from './sagas/paymentMethods';
import profile from './sagas/profile';
import purchases from './sagas/purchases';
import purchaseLands from './sagas/purchaseLands';
import purchaseSchema from './sagas/purchaseSchema';
import purchaseTickets from './sagas/purchaseTickets';
import questions from './sagas/questions';
import reviews from './sagas/reviews';
import reviewDimensions from './sagas/reviewDimensions';
import reviewStars from './sagas/reviewStar';
import sales from './sagas/sales';
import saleLands from './sagas/saleLands';
import saleReviews from './sagas/saleReviews';
import saleSchema from './sagas/saleSchema';
import saleTickets from './sagas/saleTickets';
import supplyProposals from './sagas/supplyProposals';
import user from './sagas/user';
import waivers from './sagas/waivers';
import wanteds from './sagas/wanteds';

const sagas = [
  account,
  attachments,
  bookmarks,
  builds,
  categories,
  categorySummary,
  couponFavorites,
  googleAnalytics,
  icons,
  invoices,
  myOfferings,
  myWanteds,
  notifications,
  offerings,
  offeringVideos,
  offeringReviews,
  paymentMethod,
  profile,
  purchases,
  purchaseLands,
  purchaseSchema,
  purchaseTickets,
  questions,
  reviews,
  reviewDimensions,
  reviewStars,
  sales,
  saleLands,
  saleSchema,
  saleReviews,
  saleTickets,
  supplyProposals,
  user,
  waivers,
  wanteds,
];

const initSagas = sagaMiddleware =>
  sagas.forEach(sagaMiddleware.run.bind(sagaMiddleware));

export default initSagas;
